var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-policy-holder"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.privacyPolicy)?_c('div',{staticClass:"static-page-container rtf"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyPolicy)}})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }